import { render, staticRenderFns } from "./SbEnvironmentBorder.vue?vue&type=template&id=5c6fa44e"
import script from "./SbEnvironmentBorder.vue?vue&type=script&lang=js"
export * from "./SbEnvironmentBorder.vue?vue&type=script&lang=js"
import style0 from "./SbEnvironmentBorder.vue?vue&type=style&index=0&id=5c6fa44e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports